import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private mobileOpenSubject = new BehaviorSubject<boolean>(false);
  mobileOpen = this.mobileOpenSubject.asObservable();

  constructor() {}

  toggle() {
    this.mobileOpenSubject.next(!this.mobileOpenSubject.value);
  }
}
